<template>
    <div class="menu_area">

        <!--<div class="shoplist_pane_top_location_text" v-if="($root.info.order_temp_info.order_type == 'delivery' && info.order_temp_info.order_address != null)">
            <div class="location_text_1">{{label['search_address_text']}}:</div>
            <div class="location_text_2" @click="$router.push('/')">{{info.order_temp_info.order_address["address_" + this.info.lang]}}</div>
        </div>-->

        <div class="menu_area_content">

            <div class="menu_area_bottom_cart_btn_fix_div display_responsive isflex" @click="$root.openCart()">
                <div class="cart_btn_text">{{label['menu_check_the_cart_text']}}</div>
                <div class="cart_amount_item_count_div">
                    <div class="cart_amount" v-if="cart.items.length > 0">
                        <money :price="cart.amount" />
                    </div>
                    <div class="cart_amount" v-if="cart.items.length <= 0">
                        <money :price="0" />
                    </div>
                    <div class="cart_item_count">{{ cartItemCount }}</div>
                </div>
            </div>

            <div class="menu_content_area">
                <div class="menu_back_area display_responsive">
                    <!--<div class="menu_back_btn" @click="$root.goBack()"></div>-->
                    <!--<div class="menu_back_btn" @click="$router.replace('/shop');"></div>-->
                    <div class="menu_back_btn" @click="$router.replace('/');"></div> <!-- back to home for Tenren -->
                </div>

                <div class="shop_data_area menu_area_max_width">
                    <div class="shop_image_area" :class="{disable: displayShop.shopImage == ''}">

                        <div class="shop_image_outer_div">
                            <div class="shop_image_inner_div">
                                <img loading="lazy" :src="displayShop.shopImage" :onerror="'this.onerror=null;this.src=\'/files/images/shop_image/default_shop.png\';'" align="absmiddle" />
                            </div>
                        </div>

                    </div>
                    <div class="shop_info_area">

                        <div class="shop_name_div">
                            {{ displayShop["name" + getItemSubfix()] }}
                        </div>
                        <div class="shop_desc_div" v-if="!$root.CheckOrderModeIsShopping">
                            {{ displayShop["address" + getItemSubfix()] }}
                        </div>
                        <div class="shop_desc_div" v-html="displayShop['businessHoursLabel' + getItemSubfix()]">
                        </div>
                        <div class="shop_address_note_div" v-html="displayShop['addressNote' + getItemSubfix()]">
                        </div>

                        <!--<div class="order_type_tag_div">                        
                            <div class="order_type_select_tag" v-if="$root.info.order_setting.orderType.indexOf('delivery') >= 0" :class="{active : $root.info.order_temp_info.order_type == 'delivery'}" @click="$root.MenuPageChangeOrderType('delivery')">{{$root.GetOrderModePickupTypeLabel(1)}}</div>
                            <div class="order_type_select_tag" v-if="$root.info.order_setting.orderType.indexOf('pickup') >= 0" :class="{active : $root.info.order_temp_info.order_type == 'pickup'}" @click="$root.MenuPageChangeOrderType('pickup')">{{$root.GetOrderModePickupTypeLabel(2)}}</div>
                            <div class="order_type_select_tag" v-if="$root.info.order_setting.orderType.indexOf('pickupShop') >= 0" :class="{active : $root.info.order_temp_info.order_type == 'pickupShop'}" @click="$root.MenuPageChangeOrderType('pickupShop')">{{$root.GetOrderModePickupTypeLabel(3)}}</div>
                        </div>-->
                        <div class="order_type_tag_readyTime_div">
                            <div class="order_readyTime_text" v-if="info.order_temp_info.order_time == 'asap'">
                            
                                <div class="location_text" v-if="(!$root.CheckOrderModeIsShopping && $root.info.order_temp_info.order_type == 'delivery' && info.order_temp_info.order_address != null)">
                                    <div class="location_text_1">{{label['search_address_text']}}:</div>
                                    <div class="location_text_2">{{info.order_temp_info.order_address["address_" + this.info.lang]}}</div>
                                </div>
                                <div class="location_text" v-if="($root.CheckOrderModeIsShopping && $root.info.order_temp_info.order_type == 'delivery' && info.order_temp_info.order_address != null)">
                                    <div class="location_text_1">{{label['search_address_text_shopping']}}:</div>
                                    <div class="location_text_2">{{info.order_temp_info.order_address["address_" + this.info.lang]}}</div>
                                </div>

                                <div class="estimate_text">
                                    <div class="estimate_text_1">{{label['order_asap_estimate_time_label']}}:</div>
                                    <!--<div class="estimate_text_2">{{info.order_temp_info.order_date}} {{$root.OrderDateSelect.format('HH:mm')}}({{ $root.OrderDateSelectShopReadyTime }})</div>-->
                                    <div class="estimate_text_2">{{label['order_asap_estimate_time_label_about']}} {{ $root.OrderDateSelectShopReadyTime }} {{label['order_asap_estimate_time_label_min']}} ({{$root.OrderDateSelect.format('HH:mm')}})</div>
                                </div>

                            </div>
                            <div class="order_readyTime_text" v-if="info.order_temp_info.order_time != 'asap'">

                                <div class="location_text" v-if="(!$root.CheckOrderModeIsShopping && $root.info.order_temp_info.order_type == 'delivery' && info.order_temp_info.order_address != null)">
                                    <div class="location_text_1">{{label['search_address_text']}}:</div>
                                    <div class="location_text_2">{{info.order_temp_info.order_address["address_" + this.info.lang]}}</div>
                                </div>
                                <div class="location_text" v-if="($root.CheckOrderModeIsShopping && $root.info.order_temp_info.order_type == 'delivery' && info.order_temp_info.order_address != null)">
                                    <div class="location_text_1">{{label['search_address_text_shopping']}}:</div>
                                    <div class="location_text_2">{{info.order_temp_info.order_address["address_" + this.info.lang]}}</div>
                                </div>

                                <div class="estimate_text" v-if="!$root.CheckOrderModeIsShopping">
                                    <div class="estimate_text_1">{{label['order_asap_estimate_time_label']}}:</div>
                                    <div class="estimate_text_2">{{info.order_temp_info.order_date}} {{info.order_temp_info.order_time}}</div>
                                </div>
                                <div class="estimate_text" v-if="$root.CheckOrderModeIsShopping" style="display:none;"> <!-- tenren no need dispaly the date for shopping -->
                                    <div class="estimate_text_1">{{label['order_asap_estimate_time_label_shopping']}}:</div>
                                    <div class="estimate_text_2">{{info.order_temp_info.order_date}}</div>
                                </div>

                            </div>
                        </div>

                        <!--<div class="shop_common_msg_div" v-html="displayShop['common_message' + getItemSubfix()]">
                        </div>-->

                    </div>
                </div>
                <!-- shop_data_area end -->

                <!--<div class="shop_promote_msg_area">
                    <div class="shop_promote_msg_inner_area menu_area_max_width">
                        <div class="shop_promote_msg_div" v-html="displayShop['promote_message' + getItemSubfix()]"></div>
                    </div>
                </div>-->
                <!-- shop_promote_msg_area  end -->

                <div class="menu_data_area top_border" id="menu_data_area" v-if="categories.length <= 0">{{label['menu_no_menu_item_in_current_text']}}</div>

                <div class="menu_data_area" id="menu_data_area" v-if="categories.length > 0">

                    <!-- menu_category_area start -->
                    <div class="menu_category_area" ref="menu_category_area" :style="{'top':$root.header_div_info.height+'px'}">
                        <div class="menu_cate_outer_div scroller menu_area_max_width" id="menu_cate_outer_div" :key="$root.menuIsUpdate">
                            
                            <div class="menu_cate_div"
                                    v-for="(category, index) in categories"
                                    v-bind:id="`cateSelect${category.id}`"
                                    :key="'category'+index"
                                    :class="{ active: (currentCategory != null && category.id == currentCategory.id) }"
                                    @click="selectCategory(category)">
                                <div class="menu_cate_cover">
                                    <div class="menu_cate_name">
                                        {{ category["nameSales" + getItemSubfix()] }}
                                    </div>
                                </div>
                            </div>
                            <!--
                            <div class="menu_cate_div"
                                    v-for="(page, index) in info.ShopCategoryStatisPage"
                                    :class="{ active: page.page_code == currentShopCategoryPage }"
                                    @click="selectShopCategoryStatisPage(page)">
                                <div class="menu_cate_cover">
                                    <div class="menu_cate_name">
                                        {{ page["page_title_" + getItemSubfix()] }}
                                    </div>
                                    <div class="menu_cate_bar">
                                    </div>
                                </div>
                            </div>
                            -->
                           
                        </div>
                    </div>
                    <!-- menu_category_area end -->

                    <!-- menu_item_area start -->
                    <div class="menu_item_area" :key="$root.menuIsUpdate">

                        <div class="menu_item_list_area menu_area_max_width"
                             v-for="(cate, j) in allCategoryFoodArr"
                             v-bind:id="`cateContent${cate.data.id}`"
                             >
                            <div class="menu_item_cate_name_div" v-if="cate">
                                <div class="menu_item_cate_name">
                                    {{ cate.data["nameSales" + getItemSubfix()] }}
                                </div>
                            </div>

                            <div class="menu_item_list_div">

                                <div class="menu_item_list"
                                        v-for="(food, index) in cate.foodList"
                                        :key="cate.data.id + '-fl-' + index"
                                        :class="{ isselect: countItemInCart(food) > 0 }"
                                        >

                                    <div class="menu_item_box" :class="{ issoldout: food.soldout }" @click="selectFood(food)">
                                        <!--<div class="cart_count_area display_responsive isflex" v-if="countItemInCart(food) > 0">{{countItemInCart(food)}}</div>-->

                                        <!--<div class="menu_content_div" :class="{ isFull: food.images.length <= 0 }">-->
                                        <div class="menu_content_div" >
                                            <div class="cart_count_area isflex" v-if="countItemInCart(food) > 0">{{countItemInCart(food)}}</div>
                                            <div class="menu_name_div">
                                                {{ food["name" + getItemSubfix()] }}
                                            </div>
                                            <div class="menu_desc_div" v-html="$root.ReplaceLineBreakHtml(food['desc' + getItemSubfix()])">
                                            </div>
                                            <div class="menu_price_div">

                                                <div class="menu_price_1" :class="{isDiscount : (food.price2 != undefined && food.price2 != '')}">
                                                    <money :price="food.price" />
                                                </div>
                                                <div class="menu_price_2" v-if="food.price2 != undefined && food.price2 != ''">
                                                    <money :price="food.price2" />
                                                </div>
                                                <div class="menu_price_2 normal_text soldout" v-if="food.soldout">
                                                    {{label["menu_soldout_text"]}}
                                                </div>
                                                <div class="menu_price_message isnew" v-if="checkItemIconNew(food, 'new')">
                                                    <div class="message_icon">
                                                    </div>
                                                </div>
                                                <div class="menu_price_message isGreenDish" v-if="checkItemIconNew(food, 'greendish')">
                                                    <div class="message_icon">
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="menu_image_div" v-if="food.images.length > 0">                                            
                                            <div class="menu_image_inner_div">
                                                <img loading="lazy" :src="food.images[0]" :onerror="'this.onerror=null;this.src=\'/files/images/main/img_item_placeholder.png\';'" align="absmiddle" />
                                            </div>
                                        </div>
                                        <div class="menu_image_div" v-if="food.images.length <= 0">                                            
                                            <div class="menu_image_inner_div">
                                                <img loading="lazy" src="/files/images/main/img_item_placeholder.png" align="absmiddle" />
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </div>
                        <!-- menu_item_area end -->

                        <transition name="fade" mode="out-in">
                            <router-view class="menu_item_details"></router-view>
                        </transition>

                    </div>


                </div>
                <!-- menu_data_area end -->

            </div>
            

            <div class="common_cart_list_width display_desktop"></div>
        </div>





        <transition name="slide-up">
            <div class="item_details_area" v-if="foodSelect_currentFood" :style="{'height':$root.full_screen_height.height_fix}">

                <div class="item_details_div">

                    <!--<MiddlePageTopMenuBar v-bind:pageType="'itemDetails'" v-bind:pageBackAction="selectFoodClose" >
                    </MiddlePageTopMenuBar>-->

                    <div class="middle_page_top_menu_bar">
                        <div class="left_div">
                            <div class="back_btn" @click="selectFoodClose()"></div>
                        </div>
                        <div class="right_div">
                            <div class="right_div_text">{{ foodSelect_currentFood["name" + getItemSubfix()] }}</div>
                        </div>
                    </div>
                    
                    <div class="item_details_header_area" v-if="itemDetailsDisplayVersion == 1">
                        <!--<div class="item_details_back_btn display_responsive isflex" @click="selectFoodClose()">
                            <div class="ico_div"></div>
                        </div>-->
                        <div class="item_details_header_food_name">
                            {{ foodSelect_currentFood["name" + getItemSubfix()] }}
                        </div>
                        <div class="item_details_close_btn display_desktop isflex" @click="selectFoodClose()">
                            <div class="ico_div"></div>
                        </div>
                    </div>
                    <div class="item_details_header_area display_desktop isflex" v-if="itemDetailsDisplayVersion == 2">
                        <div class="item_details_header_food_name">
                            {{ foodSelect_currentFood["name" + getItemSubfix()] }}
                        </div>
                        <div class="item_details_close_btn display_desktop isflex" @click="selectFoodClose()">
                            <div class="ico_div"></div>
                        </div>
                    </div>                    
                    <!-- item_details_header_area end -->

                    <div class="item_details_body_area" id="item_details_body_area">

                        <div class="item_info_area" v-if="itemDetailsDisplayVersion == 1">
                            <div class="item_info_image_div" v-if="foodSelect_currentFood.images.length > 0">
                                <div class="item_info_image_inner_div">
                                    <img loading="lazy" :src="foodSelect_currentFood.images[0]" :onerror="'this.onerror=null;this.src=\'/files/images/main/img_item_placeholder.png\';'" align="absmiddle" />
                                </div>
                            </div>
                            <div class="item_info_desc_div" v-if="foodSelect_currentFood['desc'+getItemSubfix()] != ''" v-html="$root.ReplaceLineBreakHtml(foodSelect_currentFood['desc'+getItemSubfix()])"></div>
                        </div>
                        <div class="item_info_area_v2" v-if="itemDetailsDisplayVersion == 2">

                            <div class="item_info_image_main_div" v-if="foodSelect_currentFood.images.length > 0">
                                
                                <div ref="itemImageSlide" class="item_info_image_div">
                                    <div class="item_info_image_slick_div" 
                                            v-for="(m, index) in foodSelect_currentFood.images"
                                            :key="'fm'+index"
                                         >
                                        <img loading="lazy" :src="m" :onerror="'this.onerror=null;this.src=\'/files/images/main/img_item_placeholder.png\';'" align="absmiddle" />
                                    </div>                                   
                                </div>
                            </div>

                            <div class="item_info_desc_div" v-if="foodSelect_currentFood['desc'+getItemSubfix()] != ''">
                                <!--<div class="item_title_div display_responsive">{{ foodSelect_currentFood["name" + getItemSubfix()] }}</div>-->
                                <div class="item_desc_div" v-html="$root.ReplaceLineBreakHtml(foodSelect_currentFood['desc'+getItemSubfix()])"></div>
                            </div>
                        </div>
                        <!-- item_info_area end -->

                        <div class="item_option_area"
                             v-for="(page, index) in foodSelect_allPage"
                             :key="index"
                             :id="'food_page_'+index"
                             :class="{isAlert : foodSelect_ShownotCompletePage && page.isAlert}">

                            <!-- option type option start -->
                            <div class="item_option_div" v-if="page.type=='option' || page.type=='comboOption' ||  page.type=='fixItem'">
                                <div class="item_option_group">

                                    <div class="item_option_name_div">
                                        {{page.data['name'+getItemSubfix()]}}
                                        <span>{{PageRequiredMessageLabel(page.data)}}</span>
                                    </div>

                                    <div class="item_option_list_div">

                                        <!-- loop item start -->
                                        <div class="item_option_list" v-for="(oi, index) in page.data.items" :key="index" :class="{active: oi.qty > 0, disabled: page.data.isSelectNoItem || (oi.qty == 0 && page.data.totalQty >= page.data.maxQty), notAvailable: !oi.available}">

                                            <div class="item_option_list_select_div" v-if="page.type == 'comboOption'" @click="page.selectItem($event,page, page.data, oi)">
                                                <div class="click_div">
                                                    <div class="click_icon"></div>
                                                </div>
                                                <div class="option_name_div">
                                                    {{oi['name'+getItemSubfix()]}}
                                                </div>
                                                <div class="option_price_div">
                                                    <span v-if="oi.price>0"><money :price="oi.price" /></span>
                                                </div>
                                            </div>
                                            <div class="item_option_list_select_div" v-if="(page.data.maxQty == 1 || page.type == 'fixItem') && page.type != 'comboOption'" @click="page.selectItem($event,page, page.data, oi)">
                                                <div class="click_div">
                                                    <div class="click_icon"></div>
                                                </div>
                                                <div class="option_name_div">
                                                    {{oi['name'+getItemSubfix()]}}
                                                </div>
                                                <div class="option_price_div">
                                                    <span v-if="oi.price>0"><money :price="oi.price" /></span>
                                                </div>
                                            </div>
                                            <div class="item_option_list_select_div isMuti" v-if="(page.data.maxQty > 1 && page.type != 'fixItem') && page.type != 'comboOption'">
                                                <div class="option_qty_div">
                                                    <div class="min_div" @click="page.selectItemQty($event,page, page.data, oi, 'min')"></div>
                                                    <div class="qty_div">{{oi.qty}}</div>
                                                    <div class="add_div" @click="page.selectItemQty($event,page, page.data, oi, 'add')"></div>
                                                </div>
                                                <div class="option_name_div">
                                                    {{oi['name'+getItemSubfix()]}}
                                                </div>
                                                <div class="option_price_div">
                                                    <span v-if="oi.price>0"><money :price="oi.price" /></span>
                                                </div>
                                            </div>

                                            <transition name="sliderDivFast">
                                                <div class="item_option_list_select_modify_div" v-if="page.mPage.filter(p => p.parent_item_id == oi.id).length > 0">

                                                    <!-- loop option modifier start -->
                                                    <div class="item_option_modifier_area"
                                                         v-for="(mPage, mPage_index) in page.mPage.filter(p => p.parent_item_id == oi.id)"
                                                         :key="'om'+mPage_index"
                                                         :class="{isEdit : mPage.isEdit}">

                                                        <div class="item_option_modifier_header_tag">
                                                            <div class="item_option_modifier_header_text">
                                                                ({{mPage_index+1}}) {{label['menu_item_modifier_header_text']}}
                                                            </div>
                                                            <div class="item_option_modifier_header_btn" @click="ItemModifierEditBtnClick($event,mPage)"></div>
                                                        </div>
                                                        <transition name="sliderDivFast">
                                                            <div style="width:100%;" v-if="mPage.isEdit">
                                                                <div class="item_option_modifier_area_tag"
                                                                     v-for="(omd, omd_index) in mPage.data"
                                                                     :key="'omd'+omd_index">

                                                                    <div class="item_option_name_div">
                                                                        {{omd['name'+getItemSubfix()]}}
                                                                        <span :class="{noAlert : omd.minQty == 0}">{{PageRequiredMessageLabel(omd)}}</span>
                                                                    </div>

                                                                    <div class="item_option_list_div">

                                                                        <!-- loop item start -->
                                                                        <div class="item_option_list" v-for="(omm, index) in omd.modifiers" :key="'omm'+index" :class="{active: omm.qty > 0, disabled:omm.qty == 0 && omd.totalQty >= omd.maxQty}">

                                                                            <div class="item_option_list_select_div" @click="mPage.selectItem($event,mPage, omd, omm)">
                                                                                <div class="click_div">
                                                                                    <div class="click_icon"></div>
                                                                                </div>
                                                                                <div class="option_name_div">
                                                                                    {{omm['name'+getItemSubfix()]}}
                                                                                </div>
                                                                                <div class="option_price_div">
                                                                                    <span v-if="omm.price>0"><money :price="omm.price" /></span>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                        <!-- loop item end -->

                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </transition>

                                                    </div>
                                                    <!-- loop option modifier start -->

                                                </div>
                                            </transition>

                                        </div>
                                        <!-- loop item end -->

                                        <!-- select no item start change to bottom on 20221220 -->
                                        <div class="item_option_list" v-if="page.data.minQty == 0" :class="{active: page.data.isSelectNoItem, disabled: page.data.complete && !page.data.isSelectNoItem}">

                                            <div class="item_option_list_select_div" @click="page.selectNoItem($event,page, page.data)">
                                                <div class="click_div">
                                                    <div class="click_icon"></div>
                                                </div>
                                                <div class="option_name_div">
                                                    {{label['select_no_item']}}
                                                </div>
                                                <div class="option_price_div">
                                                </div>
                                            </div>

                                        </div>
                                        <!-- select no item end -->

                                    </div>
                                </div>

                            </div>
                            <!-- option type option end -->

                            <!-- option type modifier start -->
                            <div class="item_option_div" v-if="page.type=='modifier'">
                                <div class="item_option_group" v-for="(mg, index) in page.data" :key="index">

                                    <div class="item_option_name_div">
                                        {{mg['name'+getItemSubfix()]}}
                                        <span :class="{noAlert : mg.minQty == 0}">{{PageRequiredMessageLabel(mg)}}</span>
                                    </div>

                                    <div class="item_option_list_div">

                                        <!-- loop item start -->
                                        <div class="item_option_list" v-for="(m, index) in mg.modifiers" :key="index" :class="{active: m.qty > 0, disabled:m.qty == 0 && mg.totalQty >= mg.maxQty}">

                                            <div class="item_option_list_select_div" @click="page.selectItem($event,page, mg, m)">
                                                <div class="click_div">
                                                    <div class="click_icon"></div>
                                                </div>
                                                <div class="option_name_div">
                                                    {{m['name'+getItemSubfix()]}}
                                                </div>
                                                <div class="option_price_div">
                                                    <span v-if="m.price>0"><money :price="m.price" /></span>
                                                </div>
                                            </div>

                                        </div>
                                        <!-- loop item end -->

                                    </div>

                                </div>
                            </div>
                            <!-- option type modifier end -->

                            <!-- option type combo start -->
                            <div class="item_option_div" v-if="page.type=='combo'">
                                <div class="item_option_group">

                                    <div class="item_option_name_div">
                                        {{page.data['name'+getItemSubfix()]}}
                                        <span>{{PageRequiredMessageLabel(page.data)}}</span>
                                    </div>

                                    <div class="item_option_list_div">

                                        <!-- loop item start -->
                                        <div class="item_option_list" v-for="(cd, index) in page.data.items" :key="index" :class="{active: cd.qty > 0, disabled:cd.qty == 0 && page.data.complete}">

                                            <div class="item_option_list_select_div" @click="page.selectItem($event, page, page.data, cd)">
                                                <div class="click_div">
                                                    <div class="click_icon"></div>
                                                </div>
                                                <div class="option_name_div">
                                                    {{cd['name'+getItemSubfix()]}}
                                                </div>
                                                <div class="option_price_div">
                                                    <span v-if="cd.price>0"><money :price="cd.price" /></span>
                                                </div>
                                            </div>

                                        </div>
                                        <!-- loop item end -->

                                        <!-- select no item start change to bottom on 20221220 -->
                                        <div class="item_option_list" v-if="page.data.minQty == 0" :class="{active: page.data.isSelectNoItem, disabled: page.data.complete && !page.data.isSelectNoItem}">

                                            <div class="item_option_list_select_div" @click="page.selectNoItem($event,page, page.data)">
                                                <div class="click_div">
                                                    <div class="click_icon"></div>
                                                </div>
                                                <div class="option_name_div">
                                                    {{label['select_no_item']}}
                                                </div>
                                                <div class="option_price_div">
                                                </div>
                                            </div>

                                        </div>
                                        <!-- select no item end -->

                                    </div>

                                </div>
                            </div>
                            <!-- option type combo end -->

                        </div>
                        <!-- item_option_area end -->

                    </div>
                    <!-- item_details_body_area end -->

                    <div class="item_qty_add_cart_area">

                        <div class="item_qty_area">
                            <div class="item_qty_div">
                                <div class="min_div" @click="foodSelect_setQty(foodSelect_currentFood.qty - 1)"></div>
                                <div class="qty_div">{{foodSelect_currentFood.qty}}</div>
                                <div class="add_div" @click="foodSelect_setQty(foodSelect_currentFood.qty + 1)"></div>
                            </div>
                        </div>

                        <div class="item_add_cart_div">
                            <div class="add_cart_btn" :class="{active: foodSelect_showConfirm}" @click="foodSelect_addToCart()">
                                <div class="text_div">
                                    {{label["add_to_cart_label"]}}
                                </div>
                                <div class="item_final_price">
                                    <money :price="foodSelect_getPrice() * foodSelect_currentFood.qty" />
                                </div>
                            </div>
                        </div>

                    </div>
                    <!-- item_qty_add_cart_area end -->

                </div>
            </div>
        </transition>



    </div>
</template>
 
<script>
    import MiddlePageTopMenuBar from "../components/MiddlePageTopMenuBar.vue";

    export default {
        data() {
            return {
                isInit: false,
                isSelectCate: false,
                //categories: [],
                menuData:[],
                currentCategory: undefined,
                allCategoryFoodArr: [],
                allCategoryScroll: [],
                selectFoodItem: null,
                currentShopCategoryPage: "",
                menu_bottom_content_enable: false,

                foodSelect_currentFood: null,
                foodSelect_showConfirm: true,
                foodSelect_notCompletePageIndex: [],
                foodSelect_ShownotCompletePage: false,
                foodSelect_pages: [],
                foodSelect_selectedOptions: [],

                displayShop: null,
                LLshopInfo: null,
                itemIcons: { "new": [] },
				
				unavailable_a: -99,
                unavailable_b: -4,
                itemSoldOutQty: 5,
            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            label() {
                return this.$root.getLabel();
            },
            currentBanner() {
                if (this.currentCategory)
                    return allBanner["category." + this.currentCategory.id];
            },
            showCouponIcon() {
                return this.$root.info.showCouponIcon != false;
            },
            cart() {
                return this.$root.cart;
            },
            cartItemCount() {
                return this.cart.itemCount(this.$root.disableItem);
            },            
            categories() {
                return this.menuData.filter(this.checkCategoriesItems);
            },
            foodList() {
                return this.getFoodList(this.currentCategory);
            },

            foodSelect_allPage() {
                return this.foodSelect_pages.filter(x => !x.isHide);
            },

            itemDetailsDisplayVersion() {
                /*
                if (this.$root.CheckOrderModeIsShopping) {
                    return 2;
                }
                else {
                    return 1;
                }
                */
                //return this.info.order_setting.itemDetailsDisplayVersion;
                return 2; // force return version 2 on 20231115
            }
        },
        components: { MiddlePageTopMenuBar },
        created() {
            // prevent cannot scroll when loading the page            
            this.$root.setBodyOverflow(false);
            this.info.itemMenuDetailsOpen = false;
            //console.log("this.cart menu", JSON.parse(JSON.stringify(this.cart)));

            this.itemSoldOutQty = this.info.itemSoldOutQty;
            if (this.$root.CheckOrderModeIsShopping) 
                this.itemSoldOutQty = 0;

            //this.$root.windowResizeEventHandler();
            this.selectFoodItem = null;

            this.info.loading = true;

            this.$root.getCurrentPathName();

            // check have brand or not
            this.$root.initSelectBrand();

            if (!this.cart.shop) {
                this.$router.replace(`/shop`);
                return;
            }
            else {
                this.displayShop = this.$root.getShopInfo(this.cart.shop.shopCode);
                //this.displayShop.shopImage = this.$root.getShopImageCheck(this.displayShop);
                this.displayShop.shopImage = this.$root.getShopImage(this.displayShop);
                //this.LLshopInfo = this.$root.getLLShopInfo(this.cart.shop.shopCode); // change to get info before use for using the updatest data
            }

            this.cart
                .loadFile("menu", (data) => {
                    //console.log("menu data", data);
                    //this.categories = data.filter(this.checkCategoriesItems);
                    this.menuData = data;
                    this.init();
                })
                .always(() => {
                    this.info.loading = false;
                });
        },
        destroyed() {
            this.selectFoodItem = null;
            this.foodSelect_currentFood = null;
            this.info.itemMenuDetailsOpen = false;
            this.$root.setBodyOverflow(false);
        },
        mounted() {            
        },
        beforeMount() {
            if (this.info.menuPageDisplayMode == 2) {
                window.addEventListener('scroll', this.checkCategoryPosition);
            }
        },
        beforeDestroy() {
            if (this.info.menuPageDisplayMode == 2) {
                window.removeEventListener('scroll', this.checkCategoryPosition);
            }
        },
        methods: {
            getFoodList(cate) {
                var app = this;
                if (cate != null && cate != undefined) {
                    //this.selectCurrentCategoryFilter();
                    app.CategoryFilter(cate);
                    if (cate.items.filter(i => i.available).length > 0) {
                        var list = cate.items.filter((x) => (x.available && !app.$root.disableItem.includes(x.id)));
                        $.each(list, (i, o) => {
                            o["images"] = this.$root.getFoodImageList(app.cart.shop, o);
                        });
                        return list;
                    }
                    else {
                        return [];
                    }
                }
                return [];
            },

            scrollToMenuCateArea(scroll_to) {
                /*
                var el = this.$refs.menu_category_area;
                if (el) {
                    el.scrollIntoView();
                }
                */
                this.$root.scrollToXY(scroll_to);
            },

            checkCategoriesItems(c) {
                var app = this;
                //var now = moment().add(app.$root.serverTimeDiff, "ms");
                var now = moment(app.$root.OrderDateSelectMenuTime);
                var re = true;

                this.LLshopInfo = this.$root.getLLShopInfo(this.cart.shop.shopCode);
                var c_item_list = [];
                var shopItemControl = {};
                $.each(c.items, (i, item) => {
                    //shopItemControl = this.getShopItemControl(this.LLshopInfo, item.plu);
                    shopItemControl = this.getShopItemControl(this.LLshopInfo, item.id);

                    item.available = app.info.hideUnavailableItem
                        ? app.cart.getItemTimeSlot(item, now)
                        : true;

                    if (item.available) {
                        item.available = (shopItemControl.qty == app.unavailable_a || shopItemControl.qty == app.unavailable_b ? false : true);
                    }

                    if (item.available && !app.$root.disableItem.includes(item.id)) {
                        c_item_list.push(item);
                    }
                });

                if (c.hide || c_item_list.length == 0) {
                    re = false;
                }

                return re;
            },

            init() {
                var app = this;

                // load item icon json start
                $.get(
                    "/files/item_icon.json",
                    data => {
                        if (data[this.cart.shop.shopCode] != undefined) {
                            this.itemIcons = data[this.cart.shop.shopCode];
                        }
                    },
                    "JSON"
                );
                // load item icon json end

                // init all category with items when mode = 2
                if (this.info.menuPageDisplayMode == 2) {
                    $.each(app.categories, (i, c) => {
                        app.allCategoryFoodArr.push({
                            "data": c,
                            "foodList": app.getFoodList(c)
                        });
                    });
                    app.getAllCategoryPosition();
                }
                else {
                    app.allCategoryFoodArr = [];

                    this.initParamCategory();                    
                }
                //console.log("app.allCategoryFoodArr", app.allCategoryFoodArr);

                if (this.currentCategory == undefined && this.categories.length > 0) {
                    this.selectCategory(this.categories[0], true);
                }
            },
            initParamCategory() {
                var app = this;

                if (app.info.order_temp_info.temp_default_item != "") {
                    var result = app.categories.filter(cate =>
                        cate.items.some(item => item.id == app.info.order_temp_info.temp_default_item)
                    );
                    if (result.length > 0) {
                        app.selectCategory(result[0], true);
                        result = result[0].items.filter(item => item.id == app.info.order_temp_info.temp_default_item);
                        if (result.length > 0) {
                            app.selectFood(result[0]);
                        }
                        else {
                            app.$root.alert("default_item_item_not_found");
                            app.info.order_temp_info.temp_default_item = "";
                        }
                    }
                    else {
                        app.$root.alert("default_item_item_not_found");
                        app.info.order_temp_info.temp_default_item = "";
                    }
                }
                else if (this.$route.params.cateId) {
                    var id = this.$route.params.cateId;
                    var result = this.categories.filter((c) => c.id == id);
                    if (result.length > 0) {
                        this.selectCategory(result[0], true);
                        /*
                        if ($("#cateSelect" + result[0].id).length > 0) {
                            this.setCategoryPosition($("#cateSelect" + result[0].id).offset().left);
                        }
                        else {
                            var app = this;
                            setTimeout(function () { app.setCategoryPosition($("#cateSelect" + result[0].id).offset().left); }, 1000);
                        }
                        */
                    }
                }
            },
            getAllCategoryPosition() {
                var app = this;
                //console.log('app.allCategoryScroll.length', app.allCategoryScroll.length);
                if (app.allCategoryScroll.length <= 0) {
                    if (app.categories.length > 0) {
                        if (app.$el.querySelector("#cateContent" + app.categories[0].id) == null) {
                            setTimeout(function () { app.getAllCategoryPosition(); }, 1000);
                        } else {
                            var lastCate = null;
                            var cateSelect = null;
                            var cateContent = null;
                            var contentY = 0;
                            var contentY_top = 0;
                            var contentHeight = 0;
                            var contentY_to = 0;
                            var window_height = $(window).height();
                            $.each(app.categories, (i, c) => {
                                cateSelect = app.$el.querySelector("#cateSelect" + c.id)
                                cateContent = app.$el.querySelector("#cateContent" + c.id)
                                //console.log('$(cateSelect).offset()' + c.id, $(cateSelect).offset());
                                //console.log('$(cateContent).offset()' + c.id, $(cateContent).offset());

                                contentY_top = ($(cateContent).offset().top - (app.$refs.menu_category_area.clientHeight) - app.$root.header_div_info.height + 1);
                                contentHeight = $(cateContent).outerHeight();
                                if (i + 1 >= app.categories.length - 2) {
                                    if (contentHeight >= window_height) {
                                        contentY_to = contentY_top + Math.floor(contentHeight / 2);
                                    }
                                    else if (contentHeight >= (window_height / 2)) {
                                        contentY_to = contentY_top + Math.floor(contentHeight / 4);
                                    }
                                    else {
                                        contentY_to = contentY_top + Math.floor(contentHeight / 6);
                                    }                                    
                                }
                                else {
                                    if (contentHeight >= window_height) {
                                        contentY_to = contentY_top + Math.floor(contentHeight / 1.5);
                                    }
                                    else {
                                        contentY_to = contentY_top + Math.floor(contentHeight / 3);
                                    }
                                }

                                app.allCategoryScroll.push({
                                    "id": c.id,
                                    "cate": c,
                                    "selectX": (i == 0 ? 0 : $(cateSelect).position().left),
                                    "contentY_top": contentY_top,
                                    "contentHeight": contentHeight,
                                    "contentY_from": contentY,
                                    "contentY_to": contentY_to
                                });
                                lastCate = app.allCategoryScroll[app.allCategoryScroll.length - 1];
                                contentY = lastCate["contentY_to"];
                            });

                            // add the last cate for the bottom scroll
                            app.allCategoryScroll.push({
                                "id": lastCate.id,
                                "cate": lastCate.cate,
                                "selectX": lastCate.selectX,
                                "contentY_top": lastCate.contentY_top,
                                "contentHeight": lastCate.contentHeight,
                                "contentY_from": contentY,
                                "contentY_to": $(document).height()
                            });

                            app.initParamCategory();
                        }
                    }
                    else {
                        setTimeout(function () { app.getAllCategoryPosition(); }, 1000);
                    }
                }
                //console.log('getAllCategoryPosition', app.allCategoryScroll);
            },
            checkCategoryPosition() {
                var sy = window.scrollY;
                //console.log(sy);
                var selectCate = $(this.allCategoryScroll).filter(function (i, c) {
                    return (c.contentY_from <= sy && sy < c.contentY_to);
                });
                if (selectCate != null && selectCate.length > 0) {
                    //console.log(this.isSelectCate);
                    if (!this.isSelectCate && (this.currentCategory == undefined || this.currentCategory.id != selectCate[0].cate.id)) {
                        //this.currentCategory = selectCate[0].cate;                        
                        //window.history.replaceState(null, null, `/menu/${selectCate[0].id}`);
                        this.selectCategory(selectCate[0], false, true);
                        this.setCategoryPosition(selectCate[0].selectX, 100);
                    }
                }
            },
            setCategoryPosition(pos, time) {
                if (time == null || time == undefined) time = 0;
                $("#menu_cate_outer_div").animate({ scrollLeft: pos }, time);
            },
            checkItemIconNew(i, type) {
                if (this.itemIcons[type] != null && this.itemIcons[type].indexOf(i.id) >= 0) {
                    return true;
                }
                else {
                    return false;
                }
            },
            getItemSubfix() {
                return this.$root.getItemSubfix();
            },
            /*getFoodImage(food) {
                return this.$root.getFoodImage(food);
            },*/
            selectCategoryBackup20250128(category, isInit) {
                var app = this;
                this.menu_bottom_content_enable = true;
                this.selectFoodItem = null;
                this.currentShopCategoryPage = "";
              
                app.currentCategory = category;
                /*
                this.LLshopInfo = this.$root.getLLShopInfo(this.cart.shop.shopCode);
                //var now = moment().add(app.$root.serverTimeDiff, "ms");
                var now = moment(app.$root.OrderDateSelectMenuTime);
                var shopItemControl = {};
                $.each(app.currentCategory.items, (i, item) => {
                    //shopItemControl = this.getShopItemControl(this.LLshopInfo, item.plu);
                    shopItemControl = this.getShopItemControl(this.LLshopInfo, item.id);
                    item.soldout = (shopItemControl.qty == -1 || shopItemControl.qty < app.itemSoldOutQty ? true : false);

                    item.available = app.info.hideUnavailableItem
                        ? app.cart.getItemTimeSlot(item, now)
                        : true;

                    if (item.available) {
                        item.available = (shopItemControl.qty == app.unavailable_a || shopItemControl.qty == app.unavailable_b ? false : true);
                    }
                });
                */
                //var current_scroll = { "x": window.top.scrollX, "y": window.top.scrollY };

                /*
                if (app.info.currentPathName != `/menu/${app.currentCategory.id}`) {
                    app.$router.replace(`/menu/${app.currentCategory.id}`);
                    app.$root.getCurrentPathName();
                }
                */
                app.$router.replace(`/menu/${app.currentCategory.id}`);

                /*
                if (this.$route.params.cateId != app.currentCategory.id) {
                    app.$router.replace(`/menu/${app.currentCategory.id}`);
                }
                */
                /*
                if (!isInit) {
                    this.scrollToMenuCateArea(current_scroll);
                }
                */
                // change to scrollTo select category
                if (!isInit) {
                    var menu_data_area = app.$el.querySelector("#menu_data_area");
                    var scroll_y = ($(menu_data_area).offset().top - this.$root.header_div_info.height + 1);
                    this.$root.scrollToXY({ "x": window.top.scrollX, "y": (scroll_y < 0 ? 0 : scroll_y) });
                }
            },
            selectCategory(category, isInit, isScrollContent) {
                var app = this;
                app.isSelectCate = true;
                this.menu_bottom_content_enable = true;
                this.selectFoodItem = null;
                this.currentShopCategoryPage = "";

                app.currentCategory = category;

                if (this.info.menuPageDisplayMode == 2) {

                    if (app.allCategoryScroll.length > 0) {
                        var selectCate = $(this.allCategoryScroll).filter(function (i, c) {
                            return (c.cate.id == category.id);
                        });
                        if (!isScrollContent && (selectCate != null && selectCate.length > 0)) {
                            if (isInit) {
                                this.$root.scrollToXY({ "x": window.top.scrollX, "y": selectCate[0].contentY_top }, function () { app.isSelectCate = false; });
                            }
                            else {
                                this.$root.scrollToXYAnimate({ "x": window.top.scrollX, "y": selectCate[0].contentY_top }, function () { app.isSelectCate = false; });
                            }
                        }
                        else {
                            app.isSelectCate = false;
                        }
                    }
                    else {
                        app.isSelectCate = false;
                    }

                    if (app.currentCategory != null && app.currentCategory != undefined) {
                        window.history.replaceState(null, null, `/menu/${app.currentCategory.id}`);
                    }

                }
                else {
                    app.allCategoryFoodArr = [];
                    app.allCategoryFoodArr.push({
                        "data": category,
                        "foodList": app.getFoodList(category)
                    });
                    
                    if (app.currentCategory != null && app.currentCategory != undefined) {
                        app.$router.replace(`/menu/${app.currentCategory.id}`);
                    }

                    // change to scrollTo select category
                    if (!isInit) {
                        var menu_data_area = app.$el.querySelector("#menu_data_area");
                        var scroll_y = ($(menu_data_area).offset().top - app.$root.header_div_info.height + 1);
                        this.$root.scrollToXY({ "x": window.top.scrollX, "y": (scroll_y < 0 ? 0 : scroll_y) });
                    }

                    app.isSelectCate = false;
                }
            },
            selectCurrentCategoryFilter() {
                var cate = this.currentCategory;
                this.CategoryFilter(cate);

                // prevent loading a empty items category page
                //console.log("cate.items", cate.items.filter(i => i.available).length);
                if (cate.items.filter(i => i.available).length <= 0) {
                    cate = undefined;
                    this.init();
                }
            },
            CategoryFilter(cate) {
                var app = this;
                this.LLshopInfo = this.$root.getLLShopInfo(this.cart.shop.shopCode);
                //var now = moment().add(app.$root.serverTimeDiff, "ms");
                var now = moment(app.$root.OrderDateSelectMenuTime);
                var shopItemControl = {};
                $.each(cate.items, (i, item) => {
                    //shopItemControl = this.getShopItemControl(this.LLshopInfo, item.plu);
                    shopItemControl = this.getShopItemControl(this.LLshopInfo, item.id);
                    item.soldout = ((shopItemControl.qty == -1 || shopItemControl.qty == 0 || shopItemControl.qty < app.itemSoldOutQty) ? true : false);

                    item.available = app.info.hideUnavailableItem
                        ? app.cart.getItemTimeSlot(item, now)
                        : true;

                    if (item.available) {
                        item.available = (shopItemControl.qty == app.unavailable_a || shopItemControl.qty == app.unavailable_b ? false : true);
                    }
                });

                
            },
            getShopItemControl(shopInfo, itemCode) {
                var re_obj = { "itemCode": itemCode, "qty": 10 };
                if (shopInfo == null) {
                    return re_obj;
                }
                else {
                    if (shopInfo.itemControls == null) {
                        return re_obj;
                    }
                    else {
                        var itemList = shopInfo.itemControls.filter(i => i.itemCode == itemCode);
                        return (itemList.length > 0 ? itemList[0] : re_obj);
                    }                    
                }
            },
            selectFood(food) {
                var app = this;
                if (!food.soldout) {                    
                    app.selectFoodItem = food;

                    app.info.loading = true;
                    app.cart
                        .loadFile(app.selectFoodItem.id, data => {
                            app.foodSelect_currentFood = data;
                            app.checkOptionDataItemsAvailable(app.foodSelect_currentFood);
                            app.foodSelect_init();
                            app.$root.setBodyOverflow(true);
                            app.info.itemMenuDetailsOpen = true;
                            app.foodSelect_currentFood["images"] = app.$root.getFoodImageList(app.cart.shop, app.foodSelect_currentFood);
                            console.log("foodSelect_currentFood", app.foodSelect_currentFood);

                            // set image slide for layout version 2 start
                            if (app.itemDetailsDisplayVersion == 2) {
                                setTimeout(
                                    function () {
                                        $(app.$refs.itemImageSlide).slick({
                                            adaptiveHeight: true,
                                            autoplay: false,
                                            arrows: true,
                                            dots: false
                                        });
                                    }
                                    , 100);
                            }
                            // set image slide for layout version 2 end

                        })
                        .always(() => {
                            app.info.loading = false;
                        })
                        .fail(() => {
                            //this.exit();
                            app.$root.alert("common_fail_message");
                        });
                }
                else {
                    if (app.info.order_temp_info.temp_default_item != "") {
                        app.$root.alert("default_item_item_not_found");
                        app.info.order_temp_info.temp_default_item = "";
                    }
                }
            },
            selectFoodClose() {
                if (this.$refs.itemImageSlide) {
                    $(this.$refs.itemImageSlide).slick("unslick");
                }

                this.info.itemMenuDetailsOpen = false;
                this.selectFoodItem = null;
                this.foodSelect_currentFood = null;
                this.foodSelect_currentPage = 0;
                this.foodSelect_notCompletePageIndex = [];
                this.foodSelect_pages = [];
                this.foodSelect_selectedOptions = [];
                this.$root.setBodyOverflow(false);
            },

            selectShopCategoryStatisPage(page) {
                this.menu_bottom_content_enable = false;
                this.selectFoodItem = {};
                this.currentShopCategoryPage = page.page_code;
                this.currentCategory = undefined;
                this.$root.selectShopCategoryStatisPage(page);
            },

            countItemInCart(item) {
                var select_item = this.cart.items.filter(i => i.id == item.id);
                if (select_item.length <= 0) {
                    return 0;
                }
                else {
                    var qty = 0;
                    $.each(select_item, (i, item) => {
                        qty += item.qty;
                    });
                    return qty;
                }
            },

            // foodSelect start
            foodSelect_init() {
                var app = this;
                if (this.foodSelect_currentFood == undefined) {
                    //this.exit();
                    return;
                }

                app.foodSelect_currentFood.qty = 1;
                if (app.foodSelect_currentFood.showModifierFrist == undefined || app.foodSelect_currentFood.showModifierFrist == null)
                    app.foodSelect_currentFood.showModifierFrist = true;


                if (app.foodSelect_currentFood.showModifierFrist) {
                    // add modifier page
                    app.initFoodSelectCurrentFoodModifier();

                    // add option page
                    app.initFoodSelectCurrentFoodOption();
                }
                else {
                    // add option page
                    app.initFoodSelectCurrentFoodOption();

                    // add modifier page
                    app.initFoodSelectCurrentFoodModifier();
                }

                //console.log("app.foodSelect_pages 1", JSON.parse(JSON.stringify(app.foodSelect_pages)));
                //$.each(app.foodSelect_pages, (i, page) => {
                    //multiSort(page.data, { "minQty": "desc" });
                //});                
                //console.log("app.foodSelect_pages 2", JSON.parse(JSON.stringify(app.foodSelect_pages)));

                app.foodSelect_checkAllOptionSelected();
            },
            initFoodSelectCurrentFoodOption() {
                var check_combo_code = "_combo";
                var check_fixItem_code = "_fixItem";
                var app = this;
                if (app.foodSelect_currentFood.options.length > 0) {
                    
                    var option_combo_code = "";
                    $.each(app.foodSelect_currentFood.options, (i, o) => {
                        // set item modifierGroup data first
                        $.each(o.items, (j, item) => {
                            item.modifierGroup = app.foodSelect_getModifierGroup(item.modifierGroup);
                        });
                        o.totalQty = 0;
                        //console.log("o", o);
                        option_combo_code = "";

                        // check contains items or not
                        if (o.items == undefined || o.items == null) {
                            o.items = [];
                        }

                        // check option is combo or not
                        if (o.id.indexOf(check_combo_code) >= 0) {
                            option_combo_code = o.id.substring(o.id.indexOf(check_combo_code) + 1);

                            var temp_combo = app.foodSelect_pages.filter(p => p.data.id == option_combo_code);
                            if (temp_combo.length > 0) {
                                app.addComboPageItems(temp_combo[0], JSON.parse(JSON.stringify(o)));
                            } else {
                                var option_combo_obj = {};
                                option_combo_obj.code = o.id.substring(o.id.indexOf(check_combo_code) + 1);
                                option_combo_obj.name1 = this.ReturnComboGroupName(o.name1);
                                option_combo_obj.name2 = this.ReturnComboGroupName(o.name2);
                                option_combo_obj.name3 = this.ReturnComboGroupName(o.name3);

                                app.addComboPage(option_combo_obj, JSON.parse(JSON.stringify(o)));
                            }

                        }
                        // check option is fixItem or not
                        else if (o.id.indexOf(check_fixItem_code) >= 0) {

                            o.notDisplayMessage = true;
                            o.finish = true;
                            o.isSelectNoItem = false;
                            o.complete = true;

                            // set all item to 1 and check have modifier or not
                            var fixItem_mPage = [];
                            $.each(o.items, (j, item) => {
                                item.qty = 1;

                                if (item.modifierGroup.length > 0) {
                                    fixItem_mPage.push(this.writeModifierPageObj(item));
                                }
                            });
                            o.totalQty = o.items.count;

                            app.foodSelect_pages.push({
                                type: "fixItem",
                                data: o,
                                selectItem: app.foodSelect_NoAction,
                                selectNoItem: app.foodSelect_NoAction,
                                selectItemQty: app.foodSelect_NoAction,
                                finish: o.finish,
                                isHide: o.isHide,
                                complete: (o.complete ? true : false),
                                mPage: fixItem_mPage
                            });
                        }
                        else {
                            
                            if (o.minQty == 1 && o.maxQty == 1 && o.items.length == 1) {
                                o.finish = true;
                                o.isSelectNoItem = false;
                                o.complete = true;
                                o.items[0].qty = 1;
                                o.totalQty = o.items.count;

                                var oneItem_mPage = [];
                                if (o.items[0].modifierGroup.length > 0) {
                                    oneItem_mPage.push(this.writeModifierPageObj(o.items[0]));
                                }

                                app.foodSelect_pages.push({
                                    type: "option",
                                    data: o,
                                    selectItem: app.foodSelect_NoAction,
                                    selectNoItem: app.foodSelect_NoAction,
                                    selectItemQty: app.foodSelect_NoAction,
                                    finish: o.finish,
                                    isHide: o.isHide,
                                    complete: (o.complete ? true : false),
                                    mPage: oneItem_mPage
                                });
                            }
                            else {

                                // add normal options
                                if (o.minQty == 0) {
                                    o.minQty = 0;
                                    //o.finish = true;
                                    //o.isSelectNoItem = true;
                                    //o.complete = true; // option group is complete because minQty can be 0
                                    o.finish = false;
                                    o.isSelectNoItem = false; // will not auto select no item update on 20221220
                                    o.complete = false; 
                                }

                                app.foodSelect_pages.push({
                                    type: "option",
                                    data: o,
                                    selectItem: app.foodSelect_selectItem,
                                    selectNoItem: app.foodSelect_selectNoItem,
                                    selectItemQty: app.foodSelect_selectItemQty,
                                    finish: o.finish,
                                    isHide: o.isHide,
                                    complete: (o.complete ? true : false),
                                    mPage: []
                                });

                            }
                        }
                        
                    });

                    app.foodSelect_showConfirm = false;
                }
            },
            initFoodSelectCurrentFoodModifier() {
                var app = this;
                app.LLshopInfo = app.$root.getLLShopInfo(app.cart.shop.shopCode);
                var shopItemControl = null;
                var temp_modifiers = [];

                app.foodSelect_currentFood.modifierGroup = app.foodSelect_getModifierGroup(app.foodSelect_currentFood.modifierGroup);
                if (app.foodSelect_currentFood.modifierGroup.length > 0) {

                    var modifierPageFinish = true;
                    var modifierPageComplete = true;
                    $.each(app.foodSelect_currentFood.modifierGroup, (j, g) => {
                        g.totalQty = 0;

                        // check modifiers
                        temp_modifiers = [];
                        $.each(g.modifiers, (jj, mm) => {
                            shopItemControl = app.getShopItemControl(app.LLshopInfo, mm.id);
                            if (shopItemControl.qty == -1 || shopItemControl.qty == 0 || shopItemControl.qty == app.unavailable_a || shopItemControl.qty == app.unavailable_b || shopItemControl.qty < app.itemSoldOutQty) {
                            }
                            else {
                                temp_modifiers.push(mm);
                            }
                        });
                        g.modifiers = temp_modifiers;

                        // check contains items or not
                        if (g.items == undefined || g.items == null) {
                            g.items = [];
                        }

                        // check modifier minQty
                        if (g.minQty > 0) {
                            modifierPageFinish = false;
                            modifierPageComplete = false;
                            g.complete = false;
                        }
                        else {
                            g.complete = true;
                        }

                    });

                    /*
                    app.foodSelect_pages.push({
                        type: "modifier",
                        data: app.foodSelect_currentFood.modifierGroup,
                        selectItem: app.foodSelect_selectModifier,
                        //finish: true,
                        //complete: true,
                        finish: modifierPageFinish,
                        complete: modifierPageComplete,
                        isHide: false
                    });
                    */
                    // change the modifierGroup to page by pages
                    $.each(app.foodSelect_currentFood.modifierGroup, (i, g) => {
                        app.foodSelect_pages.push({
                            type: "modifier",
                            data: [g],
                            selectItem: app.foodSelect_selectModifier,
                            finish: g.complete,
                            complete: g.complete,
                            isHide: false
                        });
                    }); 

                }
            },
            addComboPage(combo, d) {
                var app = this;
                var temp_combo_group_page = {};
                var temp_combo_group_data = {};
                var temp_combo_group_data_items = [];

                var combo_minQty = 1;
                if (combo.code.indexOf("comboNo") >= 0) {
                    combo_minQty = 0;
                }

                temp_combo_group_data_items.push(this.addComboPageItemsObject(d));

                temp_combo_group_data = {
                    id:combo.code,
                    name1: combo.name1,
                    name2: combo.name2,
                    name3: combo.name3,
                    price: 0,
                    price2: 0,
                    items: temp_combo_group_data_items,
                    minQty: combo_minQty,
                    maxQty: 1,
                    //finish: (combo_minQty == 0 ? true : false),
                    //isSelectNoItem: (combo_minQty == 0 ? true : false),
                    //complete: (combo_minQty == 0 ? true : false),
                    finish: false, 
                    isSelectNoItem: false, // will not auto select no item update on 20221220
                    complete: false,
                    totalQty:0,
                }

                temp_combo_group_page = {
                    type: "combo",
                    data: temp_combo_group_data,
                    selectItem: app.foodSelect_selectCombo,
                    finish: false,
                    complete: false,
                    isHide: false,
                    mPage:[]
                };

                if (combo_minQty == 0) {
                    temp_combo_group_page.selectNoItem = app.foodSelect_selectNoItem;
                    //temp_combo_group_page.finish = true;
                    //temp_combo_group_page.complete = true;
                    temp_combo_group_page.finish = false; // will not auto select no item update on 20221220
                    temp_combo_group_page.complete = false; 
                }

                app.foodSelect_pages.push(temp_combo_group_page);
            },
            addComboPageItems(temp_combo_group_page, d) {
                temp_combo_group_page.data.items.push(this.addComboPageItemsObject(d));            
            },
            addComboPageItemsObject(d) {
                return {
                    "id": d.id,
                    "plu": d.id,
                    "name1": this.ReturnComboItemsName(d.name1),
                    "name2": this.ReturnComboItemsName(d.name2),
                    "name3": this.ReturnComboItemsName(d.name3),
                    "namek": "",
                    "type": "O",
                    "desc1": "",
                    "desc2": "",
                    "desc3": "",
                    "unitName1": "",
                    "unitName2": "",
                    "kds": "",
                    "printer": "",
                    "printerGroup": "",
                    "price": d.price,
                    "qty": 0,
                    "modifierGroup": [],
                    "comboData": JSON.parse(JSON.stringify(d))
                };
            },
            foodSelect_NoAction() {
                // no code for this function
            },
            foodSelect_getModifierGroup(modifierGroupCodes) {
                var modifierGroup = [];
                $.each(this.foodSelect_currentFood.modifierGroupList, (i, o) => {
                    if (modifierGroupCodes.length == modifierGroup.length) return true;
                    if (modifierGroupCodes.indexOf(o.id) > -1) {   

                        // check modifier minQty
                        if (o.minQty == undefined || o.minQty == null) {
                            o.minQty = 0;
                        }

                        // check modifier maxQty
                        if (o.maxQty == undefined || o.maxQty == null) {
                            o.maxQty = (o.modifiers == undefined || o.modifiers == null) ? 0 : o.modifiers.length;
                        }
                        if (o.maxQty > 0 && o.modifiers.length > 0) {
                            //modifierGroup.push($.extend(true, {}, o));
                        }

                        modifierGroup.push($.extend(true, {}, o));
                    }
                });
                return modifierGroup;
            },
            foodSelect_selectModifier(ev, page, mg, m) {
                //console.log("selectModifier", page, mg, m, this.foodSelect_currentFood);
                var oQty = m.qty,
                    sQty = 0;
                $.each(mg.modifiers, (i, m2) => {
                    if (mg.maxQty == 1) m2.qty = 0;
                    if (m != m2) sQty += m2.qty;
                });
                if (mg.maxQty > sQty) {
                    m.qty = oQty > 0 ? 0 : 1;
                    sQty += m.qty;
                }
                mg.finish = mg.minQty <= sQty;
                //mg.complete = mg.maxQty <= sQty;
                if (mg.minQty <= sQty && sQty <= mg.maxQty) {
                    mg.complete = true;
                }
                else {
                    mg.complete = false;
                }

                mg.totalQty = sQty;

                // check all modifier
                var mgg_complete_count = 0;
                $.each(page.data, (j, mgg) => {
                    //console.log("mgg", mgg);
                    if (mgg.complete)
                        mgg_complete_count++;
                });
                if (mgg_complete_count == page.data.length) {
                    page.finish = true;
                    page.complete = true;
                }
                else {
                    page.finish = false;
                    page.complete = false;
                }

                this.foodSelect_checkAllOptionSelected();
            },
            foodSelect_selectNoItem(ev, page, og) {
                //console.log("selectNoItem", page, og);
                var app = this;

                // remove combo page if selected combo
                if (og.totalQty > 0 && page.type == "combo") {
                    // get page index
                    var pageIndex = -1;
                    for (var j = app.foodSelect_pages.length - 1; j >= 0; j--) {
                        if (app.foodSelect_pages[j] == page) {
                            pageIndex = j;
                            break;
                        }
                    }

                    // remove combo page
                    if (pageIndex >= 0) {
                        app.foodSelect_pages.splice(pageIndex + 1, 1);
                    }
                }

                og.isSelectNoItem = !og.isSelectNoItem;
                page.finish = og.finish = og.isSelectNoItem;

                //page.complete = og.complete = false;
                if (og.isSelectNoItem) {
                    og.complete = true; 
                    page.complete = true; 
                } else {
                    og.complete = false;
                    page.complete = false;
                }

                og.minQty = 1; // fake vuejs to update
                og.minQty = 0;
                if (og.isSelectNoItem) {
                    $.each(og.items, (i, oi2) => {
                        oi2.qty = 0;
                    });
                    var pageIndex = this.foodSelect_resetItemMPage(page);
                }

                og.totalQty = 0;                
                this.foodSelect_checkAllOptionSelected();
            },
            foodSelect_resetItemMPage(page) {
                var pageIndex = -1;
                for (var j = this.foodSelect_pages.length - 1; j >= 0; j--)
                    if (this.foodSelect_pages[j] == page) {
                        pageIndex = j;
                    } else if (page.mPage.indexOf(this.foodSelect_pages[j]) >= 0) {
                        //this.foodSelect_pages.splice(j, 1); 
                    }
                page.mPage.splice(0, page.mPage.length);
                return pageIndex;
            },            
            foodSelect_selectItem(ev, page, og, oi) {
                if (oi.available) {
                    if (og.maxQty == 1) {

                        if (oi.qty == 1) {
                            this.foodSelect_selectItemQty(ev, page, og, oi, "min");
                        }
                        else {
                            var select_item = og.items.filter(i => i.qty > 0);
                            if (select_item.length > 0) {
                                // min other item's qty then run add function
                                $.each(select_item, (i, item) => {
                                    this.foodSelect_selectItemQty(ev, page, og, item, "min");
                                });
                                this.foodSelect_selectItemQty(ev, page, og, oi, "add");
                            }
                            else {
                                this.foodSelect_selectItemQty(ev, page, og, oi, "add");
                            }
                        }
                    }
                    else {

                        if (oi.qty > 0) {
                            this.foodSelect_selectItemQty(ev, page, og, oi, "min");
                        } else {
                            this.foodSelect_selectItemQty(ev, page, og, oi, "add");
                        }

                    }
                }
            },
            foodSelect_selectItemQty(ev, page, og, oi, action_type) {
                //console.log("selectItemQty", page, og, oi, action_type);
                if (oi.available) {
                    if (action_type == "min" && oi.qty == 0) {
                        // no action if min 0 qty
                    } else {
                        var current_total_qty = 0;
                        var new_total_qty = 0;
                        $.each(og.items, (i, oi2) => {
                            current_total_qty += oi2.qty;
                        });
                        if (action_type == "min") {
                            new_total_qty = current_total_qty - 1;
                        }
                        else if (action_type == "add") {
                            new_total_qty = current_total_qty + 1;
                        }
                        if (new_total_qty <= 0) new_total_qty = 0;

                        if (og.maxQty >= new_total_qty) {

                            // check no item select
                            if (new_total_qty == 0) {
                                if (og.minQty == 0) {
                                    //og.isSelectNoItem = true;
                                    og.isSelectNoItem = false; // will not auto select no item update on 20221220
                                } else {
                                    og.isSelectNoItem = false;
                                }
                            }
                            else {
                                og.isSelectNoItem = false;
                            }

                            // update item qty
                            if (action_type == "min") {
                                oi.qty = oi.qty - 1;
                            }
                            else if (action_type == "add") {
                                oi.qty = oi.qty + 1;
                            }
                            //console.log("oi.qty", oi.qty);


                            // check page is finish and complete
                            page.finish = og.finish = new_total_qty > 0 && og.minQty <= new_total_qty;
                            //page.complete = og.complete = new_total_qty > 0 && og.maxQty <= new_total_qty;
                            if (og.minQty <= new_total_qty && new_total_qty <= og.maxQty) {

                                // add check select no item on 20221220
                                if (og.minQty == 0 && new_total_qty == 0) {
                                    if (og.isSelectNoItem) {
                                        page.complete = og.complete = true;
                                    }
                                    else {
                                        page.complete = og.complete = false;
                                    }
                                }
                                else {
                                    page.complete = og.complete = true;
                                }

                            }
                            else {
                                page.complete = og.complete = false;
                            }

                            // check mpage start
                            if (oi.modifierGroup.length > 0) {
                                if (action_type == "min") {
                                    // remove the latest mpage
                                    var current_mpage_index = -1;
                                    var current_mpage = [];
                                    for (var x = 0; x < page.mPage.length; x++) {
                                        if (page.mPage[x].parent_item_id == oi.id) {
                                            current_mpage_index = x;
                                            current_mpage.push(page.mPage[x]);
                                        }
                                    }

                                    if (current_mpage.length > 0) {
                                        page.mPage.splice(current_mpage_index, 1);
                                    }
                                }
                                else if (action_type == "add") {
                                    // add a new mpage
                                    page.mPage.push(this.writeModifierPageObj(oi));
                                }
                            }
                            // check mpage end
                            //console.log("page.mPage", page.mPage);

                            if (page.mPage.length > 0) {
                                var app = this;
                                var item_details_body_area = app.$el.querySelector("#item_details_body_area");
                                //var before_height = item_details_body_area.scrollHeight + 0;
                                //setTimeout(function () { app.MemuScrollFit(item_details_body_area, before_height); }, 100);

                                var parent_obj = $(ev.target).closest(".item_option_list");
                                //app.ScrollToObject(item_details_body_area, parent_obj);
                                setTimeout(function () { app.ScrollToObject(item_details_body_area, parent_obj); }, 210); // after sliderDivFast transaction
                            }

                            og.totalQty = new_total_qty;
                            this.foodSelect_checkAllOptionSelected();
                        }
                    }
                }
            },
            foodSelect_checkAllOptionSelected() {       
                var app = this;
                /*
                for (var i = 0; i < app.foodSelect_pages.length; i++) {
                    console.log(i, app.foodSelect_pages[i]);
                }
                */
                var notHide_page = app.foodSelect_pages.filter(x => !x.isHide);

                //var complete_page = notHide_page.filter(x => x.complete == true);
                var complete_page_total = 0;
                app.foodSelect_notCompletePageIndex = [];
                var complete_page_total_mp = 0;
                var page_mpage = [];
                //console.log("app.foodSelect_pages", JSON.parse(JSON.stringify(app.foodSelect_pages)));
                $.each(app.foodSelect_pages, (i, page) => {                    
                    //console.log("foodSelect_checkAllOptionSelected page", JSON.parse(JSON.stringify(page)));

                    if (page.type == "modifier") {
                        if (page.complete && (page.isHide == undefined || (page.isHide != undefined && !page.isHide)))
                            complete_page_total++;
                        else
                            app.foodSelect_notCompletePageIndex.push(i);
                    }
                    else {

                        if (page.data.complete == undefined || page.data.complete) {
                            // check mPage                    
                            $.each(page.data.items, (j, oi) => {
                                if (oi.qty > 0 && page.mPage != undefined && page.mPage != null) {
                                    page.complete = true;
                                    complete_page_total_mp = 0;
                                    page_mpage = page.mPage.filter(p => p.parent_item_id == oi.id);
                                    $.each(page_mpage, (k, mp) => {
                                        //console.log("foodSelect_checkAllOptionSelected mp", JSON.parse(JSON.stringify(mp)));
                                        if (mp.complete) {
                                            complete_page_total_mp++;
                                        }
                                    });

                                    //console.log("complete_page_total_mp page.mPage.length", complete_page_total_mp +","+ page_mpage.length);
                                    if (complete_page_total_mp != page_mpage.length) {
                                        page.complete = false;
                                    }
                                }
                            });

                            if (page.complete && !page.isHide)
                                complete_page_total++;
                            else
                                app.foodSelect_notCompletePageIndex.push(i);
                        }
                        else {
                            app.foodSelect_notCompletePageIndex.push(i);
                        }

                    }
                });  

                //console.log("app.foodSelect_notCompletePageIndex", app.foodSelect_notCompletePageIndex);
                //console.log("complete_page_total", complete_page_total);
                //console.log("notHide_page", notHide_page.length);
                //console.log("complete_page", complete_page.length);
                //if (complete_page.length == notHide_page.length) {
                if (complete_page_total == notHide_page.length) {
                    app.foodSelect_showConfirm = true;
                }
                else {
                    app.foodSelect_showConfirm = false;
                }
                app.foodSelect_ShownotCompletePage = false;
            },
            foodSelect_getPrice() {
                var p = this.foodSelect_currentFood.price;

                // get price from foodSelect_pages
                var option_data = null;
                var temp_items = [];
                $.each(this.foodSelect_pages, (i, page) => {

                    if (page.type == "option" || page.type == "comboOption") {
                        // modifier data is object
                        option_data = $.extend(true, {}, page.data);      
                        //console.log("option_data", option_data);

                        // get option price
                        temp_items = option_data.items.filter(x => x.qty > 0);
                        if (temp_items.length > 0) {
                            if (option_data.price != undefined && option_data.price != null)
                                p += option_data.price;

                            $.each(temp_items, (j, item) => {
                                p += item.qty * item.price;
                            });

                            // get option modifier price
                            $.each(page.mPage, (j, mpage) => {
                                var item_modifierGroup_list = mpage.data.filter(m => m.totalQty > 0);
                                $.each(item_modifierGroup_list, (k, mg) => {
                                    //console.log("mg", mg);
                                    if (mg.price != undefined && mg.price != null)
                                        p += mg.price;

                                    $.each(mg.modifiers, (l, m) => {
                                        p += m.qty * m.price;
                                    });
                                });
                            });
                        }
                        
                    }
                    // page.type options end
                    else if (page.type == "modifier") {
                        // modifier data is array
                        option_data = JSON.parse(JSON.stringify(page.data));
                        //console.log("option_data", option_data);

                        var item_modifierGroup_list = option_data.filter(m => m.totalQty > 0);
                        $.each(item_modifierGroup_list, (k, mg) => {
                            //console.log("mg", mg);
                            if (mg.price != undefined && mg.price != null)
                                p += mg.price;

                            $.each(mg.modifiers, (l, m) => {
                                p += m.qty * m.price;
                            });
                        });
                    }
                    // page.type options end

                });

                return p;
            },
            foodSelect_setQty(qty) {
                if (qty > 0 && qty <= this.$root.cart_item_qty_arr_0[this.$root.cart_item_qty_arr_0.length - 1]) {
                    this.foodSelect_currentFood.qty = qty;
                }
            },            
            foodSelect_addToCart() {
                var app = this;
                if (this.foodSelect_showConfirm) {

                    var _food = $.extend(true, {}, this.foodSelect_currentFood);
                    _food.discountPrice = this.foodSelect_getPrice();
                    delete _food.modifierGroupList;
                    var _food_options = [];
                    var _food_modifierGroup = [];


                    // get options from foodSelect_pages
                    var option_data = null;
                    var temp_items = [];
                    var temp_modifierGroup = [];
                    var option_items = [];
                    $.each(this.foodSelect_pages, (i, page) => {

                        if (page.type == "option" || page.type == "comboOption" || page.type == "fixItem") {
                            // modifier data is object
                            option_data = $.extend(true, {}, page.data);
                            temp_items = option_data.items.filter(x => x.qty > 0);
                            option_items = [];

                            if (temp_items.length > 0) {

                                // check each items contains modifierGroup or not
                                $.each(temp_items, (j, item) => {
                                    temp_modifierGroup = page.mPage.filter(p => p.parent_item_id == item.id);

                                    if (temp_modifierGroup.length > 0) {

                                        // split items by qty if contains modifierGroup
                                        for (var x = 0; x < item.qty; x++) {
                                            var ready_item = JSON.parse(JSON.stringify(item));
                                            ready_item.qty = 1;

                                            var ready_item_modifierGroup = [];
                                            var item_modifierGroup_list = temp_modifierGroup[x].data.filter(m => m.totalQty > 0);
                                            if (item_modifierGroup_list.length > 0) {

                                                $.each(item_modifierGroup_list, (k, mg) => {
                                                    ready_item_modifierGroup.push(JSON.parse(JSON.stringify(mg)));
                                                    ready_item_modifierGroup[ready_item_modifierGroup.length - 1].modifiers = [];

                                                    $.each(mg.modifiers, (l, m) => {
                                                        if (m.qty > 0) {
                                                            ready_item_modifierGroup[ready_item_modifierGroup.length - 1].modifiers.push(JSON.parse(JSON.stringify(m)));
                                                        }
                                                    });
                                                });

                                                ready_item.modifierGroup = ready_item_modifierGroup;
                                            }
                                            else {
                                                ready_item.modifierGroup = ready_item_modifierGroup;
                                            }

                                            option_items.push(ready_item);
                                        }

                                    }
                                    // check item contains modifierGroup end
                                    else {
                                        option_items.push(item);
                                    }

                                });

                                option_data.items = option_items;
                                _food_options.push(option_data);
                            } // check contains qty items end

                        }
                        // page.type options end
                        else if (page.type == "modifier") {
                            // modifier data is array
                            option_data = JSON.parse(JSON.stringify(page.data));

                            var ready_item_modifierGroup = [];
                            var item_modifierGroup_list = option_data.filter(m => m.totalQty > 0);
                            if (item_modifierGroup_list.length > 0) {

                                $.each(item_modifierGroup_list, (k, mg) => {
                                    ready_item_modifierGroup.push(JSON.parse(JSON.stringify(mg)));
                                    ready_item_modifierGroup[ready_item_modifierGroup.length - 1].modifiers = [];

                                    $.each(mg.modifiers, (l, m) => {
                                        if (m.qty > 0) {
                                            ready_item_modifierGroup[ready_item_modifierGroup.length - 1].modifiers.push(JSON.parse(JSON.stringify(m)));
                                        }
                                    });
                                });

                                //_food_modifierGroup = ready_item_modifierGroup;
                                _food_modifierGroup = _food_modifierGroup.concat(ready_item_modifierGroup);
                            }
                            else {
                                //_food_modifierGroup = ready_item_modifierGroup;
                                _food_modifierGroup = _food_modifierGroup.concat(ready_item_modifierGroup);
                            }
                        }
                        // page.type options end

                    });

                    _food.options = _food_options;
                    _food.modifierGroup = _food_modifierGroup;
                    console.log("_food", _food);

                    this.cart.addItem(_food, -1);

                    // check itemsLimit
                    if (this.cart.itemCount() > this.cart.itemsLimit) {
                        this.$root.alert("item_count_reach_limit");
                        this.cart.items = this.cart.items.slice(0, -1);
                        return;
                    }

                    this.$root.updateCart();

                    // remove temp_default_item when success add item to cart
                    if (app.info.order_temp_info.temp_default_item != "") {
                        app.info.order_temp_info.temp_default_item = "";
                        app.$root.setOrderTempInfoData();
                    }

                    this.selectFoodClose();
                }
                else {
                    this.ShowNotCompletePage();
                }
            },
            ShowNotCompletePage() {
                var app = this;
                app.foodSelect_ShownotCompletePage = true;                

                $.each(app.foodSelect_pages, (i, page) => {
                    //console.log("ShowNotCompletePage foodSelect_pages", page);
                    //console.log("app.foodSelect_notCompletePageIndex.indexOf(i)", app.foodSelect_notCompletePageIndex.indexOf(i));
                    if (app.foodSelect_notCompletePageIndex.indexOf(i) >= 0) {
                        page.isAlert = true;
                    }
                    else {
                        page.isAlert = false;
                    }
                });

                if (app.foodSelect_notCompletePageIndex.length > 0) {
                    var item_details_body_area = app.$el.querySelector("#item_details_body_area");
                    var first_obj = app.$el.querySelector("#food_page_" + app.foodSelect_notCompletePageIndex[0]);
                    //var first_obj_top = $(first_obj).offset().top - $(item_details_body_area).offset().top;                    
                    //$(item_details_body_area).animate({ scrollTop: (item_details_body_area.scrollTop + first_obj_top) }, 200);
                    app.ScrollToObject(item_details_body_area, first_obj);
                }
            },
            ItemModifierEditBtnClick(ev, mPage) {
                var app = this;
                var item_details_body_area = app.$el.querySelector("#item_details_body_area");
                //var before_height = item_details_body_area.scrollHeight + 0;

                mPage.isEdit = !mPage.isEdit;
                if (mPage.isEdit) {
                    //setTimeout(function () { app.MemuScrollFit(item_details_body_area, before_height); }, 100);

                    //var parent_obj = $(ev.target).closest(".item_option_list");
                    var parent_obj = $(ev.target).closest(".item_option_modifier_header_tag");
                    app.ScrollToObject(item_details_body_area, parent_obj);
                }
            },
            MemuScrollFit(scroll_obj, before_height) {

                var after_height = item_details_body_area.scrollHeight + 0;
                var height_diff = after_height - before_height;

                //console.log("item_details_body_area.height()", $(scroll_obj).height());
                //console.log("item_details_body_area.scrollTop", scroll_obj.scrollTop);
                //console.log("item_details_body_area.scrollHeight", scroll_obj.scrollHeight);
                //console.log("item_details_body_area.offset", $(scroll_obj).offset());
                //console.log("$(scroll_obj).scrollTop ", $(scroll_obj)[0].scrollTop );
                //console.log("$(scroll_obj).scrollHeight ", $(scroll_obj)[0].scrollHeight );
                //console.log("$(scroll_obj).offsetHeight", $(scroll_obj)[0].offsetHeight);
                //console.log("before_height", before_height);
                //console.log("after_height", after_height);
                //console.log("height_diff", height_diff);
                if (height_diff > 0)
                    $(scroll_obj).animate({ scrollTop: (scroll_obj.scrollTop + height_diff) }, 200);
            },
            foodSelect_selectItemModifier(ev, page, mg, m) {
                //console.log("selectItemModifier", page, mg, m);
                //if (m.qty != 0 || mg.totalQty < mg.maxQty) {
                    var oQty = m.qty,
                        sQty = 0;
                    $.each(mg.modifiers, (i, m2) => {
                        if (mg.maxQty == 1) m2.qty = 0;
                        if (m != m2) sQty += m2.qty;
                    });
                    if (mg.maxQty > sQty) {
                        m.qty = oQty > 0 ? 0 : 1;
                        sQty += m.qty;
                    }
                    mg.finish = mg.minQty <= sQty;
                    //mg.complete = mg.maxQty <= sQty;
                    if (mg.minQty <= sQty && sQty <= mg.maxQty) {
                        mg.complete = true;
                    }
                    else {
                        mg.complete = false;
                    }

                    mg.totalQty = sQty;

                    // check all modifier
                    var mgg_complete_count = 0;
                    $.each(page.data, (j, mgg) => {
                        //console.log("mgg", mgg);
                        if (mgg.complete)
                            mgg_complete_count++;
                    });
                    if (mgg_complete_count == page.data.length) {
                        page.finish = true;
                        page.complete = true;
                    }
                    else {
                        page.finish = false;
                        page.complete = false;
                    }

                    this.foodSelect_checkAllOptionSelected();
                //}
            },
            foodSelect_selectCombo(ev, page, cg, cd) {
                //console.log("selectCombo", page, cg, cd);
                var app = this;

                // get page index
                var pageIndex = -1;
                for (var j = app.foodSelect_pages.length - 1; j >= 0; j--) {
                    if (app.foodSelect_pages[j] == page) {
                        pageIndex = j;
                        break;
                    }
                }

                // set combo data qty                
                if (cd.qty == 1) {
                    cd.qty = 0;
                    page.finish = cg.finish = false;
                    page.complete = cg.complete = false;
                    cg.totalQty = 0;

                    // remove combo page
                    if (pageIndex >= 0) {
                        app.foodSelect_pages.splice(pageIndex + 1, 1);
                    }

                    // set selectNoItem
                    if (cg.minQty == 0) {
                        //cg.isSelectNoItem = true;
                        //page.finish = cg.finish = true;
                        //page.complete = cg.complete = true;
                        cg.isSelectNoItem = false; // will not auto select no item update on 20221220
                        page.finish = cg.finish = false;
                        page.complete = cg.complete = false;
                    }
                }
                else {
                    // reset others items qty
                    var select_item = cg.items.filter(i => i.qty > 0);
                    if (select_item.length > 0) {
                        $.each(select_item, (i, item) => {
                            item.qty = 0;;
                        });

                        // remove combo page
                        if (pageIndex >= 0) {
                            app.foodSelect_pages.splice(pageIndex + 1, 1);
                        }
                    }

                    cd.qty = 1;
                    page.finish = cg.finish = true;
                    page.complete = cg.complete = true;
                    cg.totalQty = 1;

                    // set selectNoItem
                    if (cg.minQty == 0) {
                        cg.isSelectNoItem = false;
                    }
                }

                // add combo page
                if (cd.qty > 0) {
                    var comboData = JSON.parse(JSON.stringify(cd.comboData));
                    comboData.name1 = this.ReturnComboItemsName(comboData.name1);
                    comboData.name2 = this.ReturnComboItemsName(comboData.name2);
                    comboData.name3 = this.ReturnComboItemsName(comboData.name3);
                    comboData.finish = false;
                    comboData.isSelectNoItem = false;
                    comboData.complete = false;                     

                    // check contains items or not
                    if (comboData.items == undefined || comboData.items == null) {
                        comboData.items = [];
                    }

                    var comboPage = {
                        //type: "option",
                        type: "comboOption",
                        data: comboData,
                        selectItem: app.foodSelect_selectItem,
                        selectItemQty: app.foodSelect_selectItemQty,
                        finish: false,
                        isHide: false,
                        complete: false,
                        mPage: []
                    };

                    app.foodSelect_pages.splice(pageIndex + 1, 0, comboPage);

                    // scroll to page
                    //var item_details_body_area = app.$el.querySelector("#item_details_body_area");
                    //var scroll_to_obj = app.$el.querySelector("#food_page_" + (pageIndex + 1));
                    //app.ScrollToObject(item_details_body_area, scroll_to_obj);
                    setTimeout(function () {
                        var item_details_body_area = app.$el.querySelector("#item_details_body_area");
                        var scroll_to_obj = app.$el.querySelector("#food_page_" + (pageIndex + 1));
                        app.ScrollToObject(item_details_body_area, scroll_to_obj);
                    }, 100);
                }

                this.foodSelect_checkAllOptionSelected();
            },
            PageRequiredMessageLabel(page_data) {
                //console.log("PageRequiredMessageLabel", page_data);

                // check contains items or not
                if (page_data.items == undefined || page_data.items == null) {
                    page_data.items = [];
                }

                if (page_data.notDisplayMessage) {
                    return "";
                }
                else if (page_data.minQty == 1 && page_data.maxQty == 1 && page_data.items.length == 1) {
                    return "";
                }
                else if (page_data.minQty == 0) {
                    if (page_data.maxQty == 99) {
                        return "";
                    }
                    else {
                        return this.label['must_take_max_x_items_label'].replace(/\#no\#/g, page_data.maxQty);
                    }
                }
                else {
                    if (page_data.minQty == page_data.maxQty) {
                        return this.label['must_take_x_items_label'].replace(/\#no\#/g, page_data.maxQty);
                    }
                    else if (page_data.maxQty == 99) {
                        return this.label['must_take_min_x_items_label'].replace(/\#no\#/g, page_data.minQty);
                    }
                    else {
                        return this.label['must_take_min_max_x_items_label'].replace(/\#min_no\#/g, page_data.minQty).replace(/\#max_no\#/g, page_data.maxQty);
                    }
                }
            },
            ScrollToObject(scroll_obj, scroll_to_obj) {
                var scroll_to_obj_top = $(scroll_to_obj).offset().top - $(scroll_obj).offset().top;
                $(scroll_obj).animate({ scrollTop: (scroll_obj.scrollTop + scroll_to_obj_top) }, 200);
            },
            ReturnComboGroupName(name) {
                return name.lastIndexOf("_") >= 0 ? name.substring(name.lastIndexOf("_") + 1) : "";
            },
            ReturnComboItemsName(name) {
                return name.lastIndexOf("_") >= 0 ? name.substring(0, name.lastIndexOf("_")) : name;
            },
            writeModifierPageObj(item) {
                var app = this;
                var temp_modifierGroup = item.modifierGroup;

                app.LLshopInfo = app.$root.getLLShopInfo(app.cart.shop.shopCode);
                var shopItemControl = null;

                var modifierPageFinish = true;
                var modifierPageComplete = true;
                var temp_modifiers = [];
                $.each(temp_modifierGroup, (i, m) => {

                    // check modifiers
                    temp_modifiers = [];
                    $.each(m.modifiers, (j, mm) => {
                        shopItemControl = app.getShopItemControl(app.LLshopInfo, mm.id);
                        if (shopItemControl.qty == -1 || shopItemControl.qty == 0 || shopItemControl.qty == app.unavailable_a || shopItemControl.qty == app.unavailable_b || shopItemControl.qty < app.itemSoldOutQty) {
                        }
                        else {
                            temp_modifiers.push(mm);
                        }
                    });  
                    m.modifiers = temp_modifiers;

                    //m.finish = true;
                    //m.complete = true;
                    m.totalQty = 0;

                    // check contains items or not
                    if (m.items == undefined || m.items == null) {
                        m.items = [];
                    }

                    // check modifier minQty
                    if (m.minQty > 0) {
                        modifierPageFinish = false;
                        modifierPageComplete = false;
                        m.complete = false;
                    }
                    else {
                        m.complete = true;
                    }

                });


                return {
                    parent_item_id: item.id,
                    type: "modifier",
                    data: JSON.parse(JSON.stringify(temp_modifierGroup)),
                    selectItem: this.foodSelect_selectItemModifier,
                    //finish: true,
                    //complete: true,
                    finish: modifierPageFinish,
                    complete: modifierPageComplete,
                    //isEdit: false
                    isEdit: true
                };
            },
            // foodSelect end

            // check data.items available start
            checkOptionDataItemsAvailable(data) { 
                var app = this;
                app.LLshopInfo = app.$root.getLLShopInfo(app.cart.shop.shopCode);
                var shopItemControl = null;
                $.each(data.options, (i, opt) => {
                    $.each(opt.items, (j, item) => {
                        item.available = true;
                        //shopItemControl = app.getShopItemControl(app.LLshopInfo, item.plu);
                        shopItemControl = app.getShopItemControl(app.LLshopInfo, item.id);
                        if (shopItemControl.qty == -1 || shopItemControl.qty == 0 || shopItemControl.qty == app.unavailable_a || shopItemControl.qty == app.unavailable_b || shopItemControl.qty < app.itemSoldOutQty) {
                            item.available = false;
                        }
                    });
                });

            }
            // check data.items available end

        },
    };
</script>
